//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faTextSlash,
  faSearch,
  faLink,
} from '@fortawesome/pro-light-svg-icons';

import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount';

export default {
  name: 'AudioSearchPage',
  components: {
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    SearchLandingPage: () => import('@/components/search-lp/SearchLandingPage.vue'),
  },
  head() {
    return {
      script: [
        {
          src: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1570933904955130',
          async: true,
          crossorigin: 'anonymous',
        },
      ],
    };
  },
  data() {
    return {
      waysToUse: [
        {
          heading: this.$t(this.$wbr('audiosearch.usage_youtube_heading')),
          text: this.$t('audiosearch.usage_youtube_text'),
          image: 'https://static.moele.me/img/channels2022/audiosearch/music-urlsearch-light-and-dark.230829.png?auto=format&w=630',
        },
        {
          heading: this.$t(this.$wbr('audiosearch.usage_file_heading')),
          text: this.$t('audiosearch.accept_{formats}_less_than_{filesize}_text', { formats: '(MP3, WAV, AIFF, MP4, WMV, FLV, H.264 MOV, AVI, 3GP)', filesize: '100MB' }),
          image: 'https://static.moele.me/img/channels2022/audiosearch/music-drag-and-drop-light-and-dark.230829.png?auto=format&w=630',
          downloadSampleFiles: true,
        },
        {
          heading: this.$t(this.$wbr('audiosearch.usage_similar_heading')),
          text: this.$t(this.$wbr('user_guide.category_search_text')),
          image: 'https://static.moele.me/img/channels2022/audiosearch/music-button-light.230831.png?auto=format&w=630',
          imageDark: 'https://static.moele.me/img/channels2022/audiosearch/music-button-dark.230831.png?auto=format&w=630',
        },
      ],
      questions: [
        this.$t(this.$wbr('audiosearch.text_1')),
        this.$t(this.$wbr('audiosearch.text_2')),
        this.$t(this.$wbr('audiosearch.text_3_{item}'), { item: this.$t('term.audiosearch') }),
      ],
      benefits: [
        {
          icon: faTextSlash,
          color: 'aqua',
          heading: this.$t(this.$wbr('audiosearch.benefit_1_heading')),
        },
        {
          icon: faSearch,
          color: 'lavender',
          heading: this.$t(this.$wbr('audiosearch.benefit_2_heading_{count}'), { count: renderContentCount(this, publishedContentCounts.total.music) }),
        },
        {
          icon: faLink,
          color: 'blue',
          heading: this.$t(this.$wbr('audiosearch.benefit_3_heading_{links}'), { links: 'YouTube, Vimeo, Soundcloud, Spotify, Apple Music, Tiktok' }),
        },
      ],
      testimonials: [
        {
          text: 'I like how AudioSearch recognise instruments, especially for piano tracks. I was able to find the music I needed successfully. I definitely think it will be easy to use and useful for your customers.',
          name: 'Florian Godard, a partner at Creative Medias',
        },
        {
          text: 'I tried this feature and it works really well. It’s just awesome how quickly it analyses the content and then comes up with relevant results.',
          name: 'Internationally acclaimed video artist Tamas Boscorelli',
        },
        {
          text: 'I think AudioSearch is a very useful way of searching for tracks, especially for video creators.',
          name: 'Kazuhito Takeuchi of Japan’s highly regarded Ligar Music Library',
        },
      ],
    };
  },
  computed: {
    pageTitle() {
      return this.$t('term.audiosearch');
    },
    pageDescription() {
      return this.$t('audiosearch.page_subheading');
    },
    pageOgImage() {
      const suffix = ['ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
      return `https://static.moele.me/img/audiosearch/audiosearch-og-${suffix}.220830.jpg`;
    },
    breadcrumbList() {
      return [{
        active: false,
        name: this.$term('mediaType', 'music').text(),
        link: this.$link('/music').url(),
      }, {
        active: true,
        name: this.$t('term.audiosearch'),
        link: this.$link('/audiosearch').url(),
      }];
    },
  },
};
